<template>
  <div class="row categories">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.topCategory')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-lg-12 col-md-10 col-sm-12 ">
      <div class="card">
        <!-- <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div> -->
        <div class="card-content row">
            <div class="col-sm-12">
              <div class="pull-right" style="position:relative;z-index:2">
                <router-link class="btn btn-info btn-icon mar-bt-20 add" title="" :to="{ path: 'top-categories/add'}">
                  <img src="/static/img/icons/add.png">
                  {{ $t('general.add') }}
                </router-link>
              </div>
              <!-- <div class="pull-left">
                <el-input v-model="filters[0].value" placeholder="Search" class="icon-search"></el-input>
              </div> -->
            </div>
            <table class="table width-table" ref="sortableTable">
              <thead>
                <tr>
                  <!-- <th width="10%"></th> -->
                  <th width="10%">{{$t('general.sortOrder')}}</th>
                  <th width="30%">{{$t('catalogCateg.image')}}</th>
                  <th width="40%">{{$t('catalogCateg.name')}}</th>
                  <th width="10%"></th>
                  <th width="10%"></th>
                </tr>
              </thead>
              <!-- <draggable v-model="tableData" :element="'tbody'" @end="adjustSort"> -->
                <template v-for="(item, index) in tableData">
                  <tr class="sortableRow">
                    <td >
                      <!-- <button style="cursor: move" class="btn"><v-icon>drag_handle</v-icon></v-btn> -->
                        <input type="number"
                          min="0"
                          :placeholder="$t('general.sortOrder')"
                          v-model="item.sort_order"
                          step="1"
                          @input="onSortOrderInput(item)"
                          @keypress="onlyDigits($event)"
                          @click="selectInputText($event)"
                          class="form-control">
                        <!-- <i style="cursor: move; color: #674BD2;" class="fa fa-arrows sortHandle"></i> -->
                    </td>
                    <td >
                      <div class="cell">
                        <div class="image-table">
                          <img v-bind:src="(item.image)?item.image : ''" />
                        </div>
                      </div>
                    </td>
                    <td>{{ item.name }}</td>
                    <td>
                      <template>
                        <p-switch v-model="item.active" type="success" @input="handleActive(item)"></p-switch>
                      </template>
                    </td>
                    <td>
                      <div class="edit" @click="goToRecord(item,[],[], $event)">
                        <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                      </div>
                    </td>
                  </tr>
                </template>
              <!-- </draggable> -->
            </table>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Col, Input, Table, TableColumn, Row, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import draggable from 'vuedraggable'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Col)
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Row)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch,
      draggable
      // GeneralTopBar
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        paginationDef: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [10, 25, 50],
          show: true
        },
        searchQuery: '',
        propsToSearch: ['name'],
        tableColumns: [
        ],
        tableData: [],
        filters: [
          {
            value: '',
            prop: ['name', 'parent_category']
          }
        ],
        sortOrderChanges: {},
        debounceTimeout: null,
        swalLoading: null
      }
    },
    watch: {
      loading: function (value) {
        if (value) {
          if (this.swalLoading) {
            return
          }

          this.swalLoading = swal({
            title: `<div style="font-size: 1.2em; margin-bottom: 10px;">${this.$t('general.loading')}</div>`,
            html: `
              <div class="custom-loader"></div>
              <div style="margin-top: 10px;">${this.$t('general.justMoment')}</div>
            `,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              swal.showLoading()
            }
          })
        } else {
          if (this.swalLoading) {
            swal.close()
            this.swalLoading = null
          }
        }
      }
    },
    created () {
      this.getData()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.getData()
      },
      getData () {
        this.$nextTick(function () {
          this.loading = true
        })
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          use_sort_order: 'asc'
        }
        this.apiRequest('/topcategory', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data
          }
          this.$nextTick(() => { this.loading = false })
        })
      },
      handleActive (row) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          active: row.active ? 1 : 0,
          id: row.id,
          version: 3
        }
        // this.apiRequest('/noauth/clear-cache-company', 'GET', [this.$session.get('selectedCompany')], function () {})
        this.apiRequest('/topcategory/' + row.id, 'PUT', data, (response) => {
          if (!response.status) {
            swal(
              '',
              response.errors.error,
              'error'
            ).catch(() => {})
            row.active = !row.active
          } else {
            this.trackAdminEvent('ADMIN_TOP_CATEGORY_UPDATE', 'top_category', row.id, {
              top_category_id: row.id,
              name: row.name || null,
              active: !!row.active
            })
          }
        })
      },
      formatCategName (row) {
        if (row['parent_id']) {
          return row['parent_category']['name'] //  + ' > ' + row['name']
        } else {
          return '' // row['name']
        }
      },
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/top-categories/edit/')
      },
      adjustSort (evt) {
        if (this.tableData.length > 1) {
          var idx = evt.newIndex
          var after, before, sortOrder

          if (idx === 0) {
            before = 0
            after = this.tableData[idx + 1].sort_order
          } else if ((idx + 1) === this.tableData.length) {
            before = this.tableData[idx - 1].sort_order
            after = parseFloat(before) + 1
          } else {
            before = this.tableData[idx - 1].sort_order
            after = this.tableData[idx + 1].sort_order
          }
          sortOrder = (parseFloat(before) + parseFloat(after)) / 2
          var id = this.tableData[idx].id
          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sort_order: sortOrder,
            version: 3
          }

          this.apiRequest('/topcategory/' + id, 'PUT', data, (response) => {
            if (response.status !== true) {
              this.getData()
              swal(
                {
                  title: '',
                  text: response.errors.error,
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
            }
          })
        }
      },
      onSortOrderInput (item) {
        if (item.sort_order < 0) {
          item.sort_order = 0
        } else if (item.sort_order > 100) {
          item.sort_order = 100
        }

        this.sortOrderChanges[item.id] = item.sort_order

        if (this.debounceTimeout) {
          clearTimeout(this.debounceTimeout)
        }

        this.debounceTimeout = setTimeout(() => {
          this.sendSortOrderUpdates()
        }, 1000 * 5)
      },
      sendSortOrderUpdates () {
        const updates = Object.entries(this.sortOrderChanges).map(([id, sortOrder]) => ({
          id,
          sortOrder
        }))

        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          updates: updates
        }

        this.loading = true

        this.apiRequest('/sort-top-category-mass-update', 'PUT', data, (response) => {
          if (response.status) {
            this.getData()
          } else {
            this.loading = false
            swal(
              {
                title: '',
                text: response.errors.message || this.$t('validations.wentWrong'),
                type: 'error',
                showConfirmButton: false,
                timer: 5000
              }
            ).catch(() => {})
          }
        })

        this.sortOrderChanges = {}
        this.debounceTimeout = null
      },
      onlyDigits (event) {
        const char = String.fromCharCode(event.which)
        if (!/^\d$/.test(char)) {
          event.preventDefault()
        }
      },
      selectInputText (event) {
        event.target.select()
      }
    }
  }
</script>
<style>
  .custom-loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #674BD2; /* Sweet purple */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin: 0 auto;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/TopCategories/TopCategories.vue